<script lang="ts">
  import { i18n } from "../../i18n.svelte";
  import Sprout from "../Sprout.svelte";

  const M = {
    ja: {
      subj: "英語",
      lvl: "Lv.3",
      q: "I have ___ in Nagoya for three years.",
      opts: ["live", "lived", "lives", "living"],
      correct: "正解！",
      gain: "習得度 +12",
      mastery: "習得度",
      next: "次の問題",
    },
    en: {
      subj: "English",
      lvl: "Lv.3",
      q: "I have ___ in Nagoya for three years.",
      opts: ["live", "lived", "lives", "living"],
      correct: "Correct!",
      gain: "Mastery +12",
      mastery: "Mastery",
      next: "Next question",
    },
  } as const;
  const m = $derived(M[i18n.locale]);
</script>

<div class="scr">
  <div class="bar">
    <span class="pill"><span class="dot"></span>{m.subj}</span>
    <span class="meter" aria-hidden="true">
      {#each [1, 2, 3, 4, 5] as n}<i class:on={n <= 3}></i>{/each}
      <em>{m.lvl}</em>
    </span>
  </div>

  <div class="qcard">
    <p class="qlabel">Q.</p>
    <p class="q">{m.q}</p>
  </div>

  <ul class="opts">
    {#each m.opts as o, i}
      <li class:correct={i === 1}>
        <span>{o}</span>
        {#if i === 1}<svg viewBox="0 0 16 16" width="15" height="15"><path d="M3 8.5l3 3 7-8" stroke="currentColor" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>{/if}
      </li>
    {/each}
  </ul>

  <div class="toast">
    <Sprout size={22} stage={3} />
    <div><strong>{m.correct}</strong><span>{m.gain}</span></div>
  </div>

  <div class="foot">
    <div class="mrow">
      <span>{m.mastery}</span><span>68%</span>
    </div>
    <div class="track"><div class="fill" style="width:68%"></div></div>
    <button class="cta">{m.next}</button>
  </div>
</div>

<style>
  .scr {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    padding: 2.4rem 1rem 1rem;
    background:
      radial-gradient(120% 50% at 100% 0%, rgba(95, 179, 100, 0.12), transparent 60%),
      var(--paper-card);
    font-size: 12px;
    line-height: 1.5;
  }
  .bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .pill {
    display: inline-flex;
    align-items: center;
    gap: 0.4em;
    font-weight: 700;
    font-size: 11px;
    color: var(--green-deep);
    background: var(--sprout-soft);
    padding: 0.3em 0.7em;
    border-radius: 999px;
  }
  .pill .dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--green);
  }
  .meter {
    display: inline-flex;
    align-items: center;
    gap: 2px;
  }
  .meter i {
    width: 4px;
    height: 11px;
    border-radius: 2px;
    background: var(--line);
  }
  .meter i.on {
    background: var(--green);
  }
  .meter em {
    margin-left: 4px;
    font-style: normal;
    font-family: var(--font-mono);
    font-size: 10px;
    color: var(--muted);
  }

  .qcard {
    background: var(--paper);
    border: 1px solid var(--line);
    border-radius: 12px;
    padding: 0.85rem 0.9rem;
  }
  .qlabel {
    font-family: var(--font-mono);
    color: var(--terra);
    font-size: 10px;
    letter-spacing: 0.1em;
  }
  .q {
    margin-top: 0.2rem;
    font-weight: 500;
    color: var(--ink);
    font-size: 13px;
  }

  .opts {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
  }
  .opts li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.55rem 0.75rem;
    border: 1px solid var(--line);
    border-radius: 10px;
    background: var(--paper);
    color: var(--ink-soft);
  }
  .opts li.correct {
    border-color: var(--green);
    background: rgba(95, 179, 100, 0.14);
    color: var(--green-deep);
    font-weight: 700;
  }

  .toast {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: var(--green-deep);
    color: #fff;
    border-radius: 12px;
    padding: 0.5rem 0.75rem;
  }
  .toast strong {
    display: block;
    font-size: 12px;
  }
  .toast span {
    font-size: 10px;
    opacity: 0.8;
  }

  .foot {
    margin-top: auto;
  }
  .mrow {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    color: var(--muted);
    margin-bottom: 4px;
  }
  .track {
    height: 6px;
    border-radius: 999px;
    background: var(--paper-deep);
    overflow: hidden;
  }
  .fill {
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(90deg, var(--sprout), var(--green));
  }
  .cta {
    margin-top: 0.7rem;
    width: 100%;
    background: var(--green);
    color: #fff;
    font-weight: 700;
    font-size: 12px;
    padding: 0.7rem;
    border-radius: 10px;
  }
</style>
